import React from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { HeartPulse } from "lucide-react"; // optional heart icon

const HealthJourneyStart = ({next_step}) => {
  const navigate = useNavigate();

  return (
    <div
 
      style={{
        minHeight: "100vh",
        background: "linear-gradient(90deg, #0ce5a6, #10dbc5, #16c5f3, #00bfff)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        color: "white",
        textAlign: "center",
        padding: "20px",
      }}
    >
      {/* Step info */}
      <p style={{ opacity: 0.9, fontSize: 15, marginBottom: 30 }}>
        Step 1 of 5
      </p>

      {/* Avatar illustration */}
      <motion.div
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.8 }}
        style={{
          width: 120,
          height: 120,
          borderRadius: "50%",
          background: "rgba(255, 255, 255, 0.15)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginBottom: 20,
        }}
      >
        <HeartPulse size={60} color="white" />
      </motion.div>

      {/* Headline */}
      <motion.h2
        initial={{ y: 20, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ delay: 0.2 }}
        style={{
          fontSize: 26,
          fontWeight: 700,
          marginBottom: 12,
        }}
      >
        Let’s Begin Your Health Journey
      </motion.h2>

      {/* Subtext */}
      <motion.p
        initial={{ y: 20, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ delay: 0.3 }}
        style={{
          fontSize: 15,
          opacity: 0.85,
          marginBottom: 40,
          maxWidth: 300,
        }}
      >
        We’ll ask a few quick questions to personalize your care.
      </motion.p>

      {/* Buttons */}
      <motion.div
        initial={{ y: 30, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ delay: 0.4 }}
        style={{ display: "flex", flexDirection: "column", gap: 18 }}
      >
        <button
          className="btn btn-accent"
          style={{
            background: "white",
            color: "#7e22ce",
            border: "none",
            borderRadius: 14,
            padding: "12px 40px",
            fontWeight: 600,
            fontSize: 16,
          }}
          onClick={() => navigate("/health-assessment")}
        >
          I’m Ready
        </button>

        <button
          style={{
            background: "transparent",
            color: "white",
            border: "none",
            fontSize: 15,
            opacity: 0.9,
          }}
        >
          I need assistance →
        </button>
      </motion.div>
    </div>
  );
};

export default HealthJourneyStart;
